<template>
  <zt-dialog
    ref="dialog"
    title="输入链接"
    v-bind="$attrs"
    v-on="$listeners"
    @close="handlerClose"
    :append-to-body="true"
    :modal-append-to-body="false"
  >
    <p class="desc">添加商品支持商品地址/淘口令/二合一地址</p>
    <zt-input type="textarea" resize="none" :rows="6" placeholder="请输入内容" v-model="textarea"></zt-input>

    <div slot="footer" class="dialog-footer">
      <zt-button class="mr10" @click="onClose">取 消</zt-button>
      <zt-button type="primary" @click="submit" :loading="loading">确 定</zt-button>
    </div>
  </zt-dialog>
</template>

<script>
import ZtDialog from '@cps/ZtDialog';
import { admin_items_add_catch } from '@/api/pkEdit';
// import { encodeURIBase64 } from '@/utils/base64'
const isDEV = process.env.NODE_ENV === 'development';
export default {
  components: {
    ZtDialog,
  },
  data: () => ({
    textarea: isDEV ? '￥J28bbDxsLH8￥' : '',
    loading: false,
  }),
  props: {
    channel: {
      type: [Array],
    },
  },
  methods: {
    // 处理关闭
    handlerClose() {
      this.resetTextarea();
    },

    // 点击关闭
    onClose() {
      this.$emit('update:visible', false);
    },

    // 重置textarea
    resetTextarea() {
      this.textarea = isDEV ? '￥J28bbDxsLH8￥' : '';
    },

    // 添加
    submit() {
      let textarea = this.textarea;
      // 判空
      if (textarea.match(/^\s*$/)) {
        this.$message.error('请输入内容');
        return;
      }
      this.loading = true;
      console.log(textarea);

      admin_items_add_catch({ data: textarea }).then(({ data }) => {
        this.loading = false;

        if (data.error_code === 0) {
          if (data.catch_id != 0) {
            this.resetTextarea();
            this.$emit('update:visible', false);
            // let link = encodeURIBase64(textarea)
            let link = textarea;
            this.$router.push({
              path: '/pk-edit/edit',
              query: {
                mode: 'add',
                link: link,
                channel: JSON.stringify(this.channel),
              },
            });
          } else {
            this.$message.error('您输入的链接获取不到信息');
          }
        } else {
          this.$message.error(data.error_message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>